import { render } from "./EmployeeTimesheet.vue?vue&type=template&id=58fb3fc0"
import script from "./EmployeeTimesheet.vue?vue&type=script&lang=js"
export * from "./EmployeeTimesheet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__